import { ReactNode } from "react";
import { Button } from "../Button";
import { useNextT } from "../../i18n";
import { ManagerHelp } from "../../access/components/ManagerHelp";
import s from "./States.module.scss";

export const EmptyState = ({ icon, title, body, action }: { icon?: ReactNode; title: ReactNode; body?: string; action?: ReactNode }) => (
  <div className={s.state}>
    {icon && <div aria-hidden className={s.icon}>{icon}</div>}
    <h3 className={s.title}>{title}</h3>
    {body && <p className={s.body}>{body}</p>}
    {action && <div className={s.action}>{action}</div>}
  </div>
);

export const LoadingSkeleton = ({ rows = 3, label, variant = "lines", columns = 3 }: { rows?: number; label?: string; variant?: "lines" | "rows"; columns?: number }) => {
  const { t } = useNextT();
  if (variant === "rows") {
    return (
      <div role="status" aria-label={label ?? t("ui.loading")} className={s.rowsSkeleton}>
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} data-skeleton-row className={s.skeletonRow} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
            {Array.from({ length: columns }, (_, c) => <span key={c} />)}
          </div>
        ))}
      </div>
    );
  }
  return (
    <div role="status" aria-label={label ?? t("ui.loading")} className={s.skeleton}>
      {Array.from({ length: rows }, (_, i) => <span key={i} />)}
    </div>
  );
};

/** `retryLabel` names the button when it does more than try again (e.g. "Reload the page"). */
export const ErrorState = ({ title, body, onRetry, retryLabel }: { title?: string; body?: string; onRetry?: () => void; retryLabel?: string }) => {
  const { t } = useNextT();
  return (
    <div className={s.state} role="alert">
      <h3 className={s.title}>{title ?? t("ui.error_title")}</h3>
      {body && <p className={s.body}>{body}</p>}
      {onRetry && <div className={s.action}><Button variant="primary" onClick={onRetry}>{retryLabel ?? t("ui.retry")}</Button></div>}
      <ManagerHelp />
    </div>
  );
};
